module.exports = __webpack_public_path__ + "img/aks-black.c476b248.svg";